class FormEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const item = document.querySelector('.item');
    const area = document.querySelector('.contact-area');

    if(item) {
      item.addEventListener('change', () => {
        const selectValue =  document.querySelector('.item').value;

        if( selectValue === 'sales' || selectValue === 'risk' ){
          area.classList.add('is-active')
        } else {
          area.classList.remove('is-active')
        }
      })
    }

    if($('[name="expect"').val() === 'sales' || $('[name="expect"').val() === 'risk') {
      area.classList.add('is-active')
    }

  }
}
